module.exports = __webpack_public_path__ + "static/media/crossCircle.f2dad54f.svg";